const IPFS = require('ipfs-http-client')
const ipfs = new IPFS({ host: 'ipfs.infura.io', port: 5001, protocol: 'https' });
// connect to ipfs daemon API server
// const ipfs = ipfsClient( process.env.VUE_APP_IPFS)


class IpfsManager {
    static async SendFile(file) {
        return await ipfs.add(file)
    }
    static async ReadFile(path) {
        var result = await ipfs.get(path)
        return result[0]
    }
}

export default IpfsManager